var map = {
	"./brand_facebook.svg": "7970",
	"./brand_github.svg": "c876",
	"./brand_instagram.svg": "a26e",
	"./brand_linkedin.svg": "a79b",
	"./brand_stackoverflow.svg": "f8a5",
	"./brand_tiktok.svg": "9ba6",
	"./brand_twitter.svg": "831c",
	"./brand_website.svg": "3c25c",
	"./ic_additional_documents.svg": "4035",
	"./ic_change_password.svg": "61ea",
	"./ic_data_privacy.svg": "9589",
	"./ic_discipline_specialties.svg": "b830",
	"./ic_disciplines_specialties.svg": "3095",
	"./ic_education_history.svg": "3a62",
	"./ic_job_history.svg": "56e4",
	"./ic_licence.png": "c213",
	"./ic_notification_preference.svg": "0040",
	"./ic_passport.png": "ae8d",
	"./ic_personal info.svg": "e09f",
	"./ic_prersonal_info.svg": "294d",
	"./ic_professional_preference.svg": "c50d",
	"./ic_profile_wizard_change_password.svg": "f3c0",
	"./ic_profile_wizard_data_and_privacy_settings.svg": "a7ff",
	"./ic_profile_wizard_education_history.svg": "d09c",
	"./ic_profile_wizard_my_documents.svg": "3fc9",
	"./ic_profile_wizard_notification_preference.svg": "09f8",
	"./ic_profile_wizard_personal_info.svg": "cb84",
	"./ic_profile_wizard_professional_reference.svg": "6cbc",
	"./ic_profile_wizard_protected_information.svg": "a1c7",
	"./ic_profile_wizard_resume.svg": "a04e",
	"./ic_profile_wizard_skills.svg": "ce38",
	"./ic_profile_wizard_social_profiles.svg": "29ae",
	"./ic_profile_wizard_work_experience.svg": "37ad",
	"./ic_profile_wizard_work_preference.svg": "d551",
	"./ic_protected_information.svg": "abdd",
	"./ic_resume.svg": "e306",
	"./ic_skills.svg": "9b54",
	"./ic_socialprofiles.svg": "dc73",
	"./ic_work_preference.svg": "941e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "33c5";